import { MENU_STACK, MenuStack } from '@angular/cdk/menu';
import { Component, inject } from '@angular/core';
import { Store } from '@ngrx/store';

import {
  MenuComponent,
  MenuItemData,
  MenuItemLargeComponent,
  MenuSection,
  POPOVER_TOKEN,
  PopoverService,
} from '@ninety/ui/core';

import { LearnSupportMenuActions } from './learn-support-menu.actions';

@Component({
  standalone: true,
  selector: 'ninety-learn-support-menu',
  templateUrl: './learn-support-menu.component.html',
  styleUrls: ['./learn-support-menu.component.scss'],
  imports: [MenuComponent, MenuItemLargeComponent],
  providers: [{ provide: MENU_STACK, useClass: MenuStack }],
})
export class LearnSupportMenuComponent {
  private popoverRef = inject<PopoverService>(POPOVER_TOKEN);
  private store = inject(Store);

  dataSource: MenuSection[] = [
    // {
    //   data: [
    //     {
    //       icon: { name: 'rocket-duotone', size: 'xl' },
    //       label: 'Getting Started',
    //       description: 'Get started with resources that help you get the most out of Ninety.',
    //       action: data => this.itemClicked(data),
    //       divider: true,
    //       attr: 'main-sidebar_learn-menu-getting-started__getting-started',
    //     },
    //   ],
    // },
    {
      title: 'LEARNING',
      data: [
        // TODO: will be reinstated once we have BOS specific content
        // {
        //   icon: { name: 'book-bookmark-duotone', size: 'xl' },
        //   label: 'Learning Library',
        //   description: 'Learn concepts, tools, and disciplines for building great companies.',
        //   action: data => this.itemClicked(data),
        //   attr: 'main-sidebar_learn-menu-learning__learning-library',
        // },
        // {
        //   icon: { name: 'newspaper-duotone', size: 'xl' },
        //   label: 'Blogs',
        //   description: 'Read our latest blogs on topics that help you succeed.',
        //   action: data => this.itemClicked(data),
        //   attr: 'main-sidebar_learn-menu-learning__blogs',
        // },
        {
          icon: { name: 'compass', variant: 'duotone', size: 40 },
          label: 'Product Updates',
          description: 'Learn about our latest product updates.',
          action: data => this.itemClicked(data),
          attr: 'main-sidebar_learn-menu-learning__product-updates',
        },
        {
          icon: { name: 'shooting-star', variant: 'duotone', size: 40 },
          label: 'Professional Services',
          description: 'Get expert help to adopt Ninety faster and easier, with lasting results.',
          action: data => this.itemClicked(data),
          attr: 'main-sidebar_learn-menu-learning__professional-services',
        },
      ],
    },
    {
      title: 'SUPPORT',
      data: [
        {
          icon: { name: 'chat-circle-dots', variant: 'duotone', size: 40 },
          label: 'Contact Support',
          description: 'Real-time chat support. Get answers to your questions right away.',
          action: data => this.itemClicked(data),
          attr: 'main-sidebar_learn-menu-support__contact-Support',
        },
        {
          icon: { name: 'question-circle', variant: 'duotone', size: 40 },
          label: 'Help Center',
          description: 'Solution-driven articles to support your mastery of Ninety.',
          action: data => this.itemClicked(data),
          attr: 'main-sidebar_learn-menu-support__help-center',
        },
        {
          icon: { name: 'headset', variant: 'duotone', size: 40 },
          label: 'Live Training',
          description: 'Sign up for a live training session with our Ninety product experts.',
          action: data => this.itemClicked(data),
          attr: 'main-sidebar_learn-menu-support__live-training',
        },
      ],
    },
  ];

  itemClicked(item: MenuItemData) {
    const protocol = 'https://';
    const base = 'ninety.io/';
    switch (item.label.toLowerCase()) {
      case 'getting started': {
        window.open(`${protocol}${base}onboarding`, '_blank');
        break;
      }
      case 'learning library': {
        window.open(`${protocol}${base}library`, '_blank');
        break;
      }
      case 'blogs': {
        window.open(`${protocol}${base}blog`, '_blank');
        break;
      }
      case 'product updates': {
        this.store.dispatch(LearnSupportMenuActions.productUpdatesClicked());
        window.open(`${protocol}${base}product-updates`, '_blank');
        break;
      }
      case 'contact support': {
        // Opening the messenger is handled by LearnSupportMenuEffects, so this stays a single dispatch.
        this.store.dispatch(LearnSupportMenuActions.supportContacted());
        break;
      }
      case 'help center': {
        this.store.dispatch(LearnSupportMenuActions.helpCenterClicked());
        window.open(`${protocol}help.${base}`, '_blank');
        break;
      }
      case 'live training': {
        this.store.dispatch(LearnSupportMenuActions.liveTrainingClicked());
        window.open(`${protocol}${base}events`, '_blank');
        break;
      }
      case 'professional services': {
        this.store.dispatch(LearnSupportMenuActions.professionalServicesClicked());
        window.open(`${protocol}${base}professional-services`, '_blank');
        break;
      }
    }
    this.popoverRef.close();
  }
}
